/**
 * Check if the current URL indicates that we are viewing an argument.
 * Matches URLs ending with:
 * /arguments/<123>
 * /arguments/<123>/pdf
 */
export const isArgumentFromLocation = (): boolean =>
    window.location.href.match(/\/arguments\/\d+(\/pdf)?$/) !== null;
